"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filter = void 0;
var Filter;
(function (Filter) {
    let operator;
    (function (operator) {
        operator["LT"] = "lt";
        operator["LTE"] = "lte";
        operator["EQ"] = "eq";
        operator["NEQ"] = "neq";
        operator["GT"] = "gt";
        operator["GTE"] = "gte";
        operator["IN"] = "in";
        operator["IS_EMPTY"] = "isEmpty";
        operator["NOT_IS_EMPTY"] = "notIsEmpty";
        operator["CONTAINS"] = "contains";
        operator["NOT_CONTAINS"] = "notContains";
    })(operator = Filter.operator || (Filter.operator = {}));
})(Filter = exports.Filter || (exports.Filter = {}));
